export const jpRegister = {
  //text
  notRegistered: 'まだ登録がお済みでない方は、初回登録をお願いします。',
  notRegistered2: 'YELLoopに初めて登録される方は、まずはアカウント登録をお願いします。',
  haveAccount: '既にYELLoopのアカウントをお持ちの方は、ログインしてコミュニティの参加登録をお願いします。',
  haveAccount2: '既にアカウントをお持ちの方は、ログインしてコミュニティへの参加登録をお願いします。',
}
